import PropTypes from 'prop-types'
import React from 'react'
import { Vignette } from 'components/Vignette'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'

function ListRowImage ({ source, size, children }) {
  let elem
  if (source) {
    elem = (
      <Vignette
        size={size}
        source={source}
      />
    )
  } else {
    elem = children
  }
  return (
    <div style={{ paddingRight: STYLES_PADDING.MEDIUM }}>
      {elem}
    </div>
  )
}

ListRowImage.SIZE = Vignette.SIZE

ListRowImage.defaultProps = {
  size: ListRowImage.SIZE.MEDIUM
}

ListRowImage.propTypes = {
  children: PropTypes.element,
  source: PropTypes.string,
  size: PropTypes.oneOf(
    Object.values(ListRowImage.SIZE)
  )
}

export default ListRowImage
